/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const ClientErrorDiscriminantKey = 'type';
export const InvalidWorkspaceIconTypename = 'com.hubspot.dpg.devex.agents.models.rpc.InvalidWorkspaceIcon';
export const InvalidWorkspaceIconDiscriminant = 'INVALID_WORKSPACE_ICON';
export const InvalidWorkspaceIconDiscriminantKey = 'type';
export const RateLimitExceededTypename = 'com.hubspot.dpg.devex.agents.models.rpc.RateLimitExceeded';
export const RateLimitExceededDiscriminant = 'RATE_LIMIT_EXCEEDED';
export const RateLimitExceededDiscriminantKey = 'type';
export const VersionByConversationNotFoundTypename = 'com.hubspot.dpg.devex.agents.models.rpc.VersionByConversationNotFound';
export const VersionByConversationNotFoundDiscriminant = 'VERSION_BY_CONVERSATION_NOT_FOUND';
export const VersionByConversationNotFoundDiscriminantKey = 'type';
export const VersionNotCompletedTypename = 'com.hubspot.dpg.devex.agents.models.rpc.VersionNotCompleted';
export const VersionNotCompletedDiscriminant = 'VERSION_NOT_COMPLETED';
export const VersionNotCompletedDiscriminantKey = 'type';
export const VersionNotFoundTypename = 'com.hubspot.dpg.devex.agents.models.rpc.VersionNotFound';
export const VersionNotFoundDiscriminant = 'VERSION_NOT_FOUND';
export const VersionNotFoundDiscriminantKey = 'type';
export const VersionNotRestorableTypename = 'com.hubspot.dpg.devex.agents.models.rpc.VersionNotRestorable';
export const VersionNotRestorableDiscriminant = 'VERSION_NOT_RESTORABLE';
export const VersionNotRestorableDiscriminantKey = 'type';
export const WorkspaceByConversationNotFoundTypename = 'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceByConversationNotFound';
export const WorkspaceByConversationNotFoundDiscriminant = 'WORKSPACE_BY_CONVERSATION_NOT_FOUND';
export const WorkspaceByConversationNotFoundDiscriminantKey = 'type';
export const WorkspaceByProjectNameNotFoundTypename = 'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceByProjectNameNotFound';
export const WorkspaceByProjectNameNotFoundDiscriminant = 'WORKSPACE_BY_PROJECT_NAME_NOT_FOUND';
export const WorkspaceByProjectNameNotFoundDiscriminantKey = 'type';
export const WorkspaceNotFoundTypename = 'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceNotFound';
export const WorkspaceNotFoundDiscriminant = 'WORKSPACE_NOT_FOUND';
export const WorkspaceNotFoundDiscriminantKey = 'type';

/**
 *  Partial patch for a workspace's metadata. Each field is optional: absent means "leave unchanged",
 *  never "clear". Lets the Edit-info modal Save carry name/description/icon together, while inline
 *  rename-on-blur can send name-only without blanking the description.
 */

export const createRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'JriyNxzY1zl8-TNS3KAWOAl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const startRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'start',
  auth: 'app',
  fingerprint: 'KYet13-tzVQeNzZAnwWZ7gl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const forkRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'fork',
  auth: 'app',
  fingerprint: 'u-Bq8y08aiJH8FS44ldZKgl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'restore',
  auth: 'app',
  fingerprint: 'x-Bk5tNEi-e3p56_Jvmm0Ql_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'clone',
  auth: 'app',
  fingerprint: 'j1tdFLYdJxzX6HutSmkSSgl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'dCPJfMeJRp3X6HutSmkSSgl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByProjectNameRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getByProjectName',
  auth: 'app',
  fingerprint: '1aptyq7LV1_X6HutSmkSSgl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByConversationRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getByConversation',
  auth: 'app',
  fingerprint: 'tALXcKKsrY_X6HutSmkSSgl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDescriptionRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getDescription',
  auth: 'app',
  fingerprint: 'dCPJfMeJRp3TzgBXO8qB0wl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const renameRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'rename',
  auth: 'app',
  fingerprint: 'jtv2Hh5ecfSOUe2e_r4XmQl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateInfoRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'updateInfo',
  auth: 'app',
  fingerprint: '2skRLurNodnX6HutSmkSSgl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'mTr0JO772WiOUe2e_r4XmQl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const publishRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'publish',
  auth: 'app',
  fingerprint: '0fIE-rDnL1JhW2wE01xS4Ql_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unpublishRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'unpublish',
  auth: 'app',
  fingerprint: 'nWiR28K1pjWOUe2e_r4XmQl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPageViaIdRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getPageViaId',
  auth: 'app',
  fingerprint: 'UfQTRpAwBk0h2iC_jyMZGQl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPageViaOffsetRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getPageViaOffset',
  auth: 'app',
  fingerprint: 'Tj_izgFnSUK7-gDzmFZODQl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const toggleFavoriteRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'toggleFavorite',
  auth: 'app',
  fingerprint: 'knuDSYheQYSg7AfReK_37gl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSuggestedPromptsRpc = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getSuggestedPrompts',
  auth: 'app',
  fingerprint: '0pFBLyfCT9ZIdDI6UzJ2Zwl_PMVJQM2e',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};